export const Storage_Keys = {
  authtoken: 'authtoken',
}
